import React from 'react'
import { Img } from 'react-image'
import LazyLoad from 'react-lazyload'
import PropTypes from 'prop-types'
import Spinner from './Spinner'
import { cardProps } from '../props'
import classNames from 'classnames'
import styles from './CardImage.module.scss'
import { v4 } from 'uuid'

const MySpinner = () => (
  <div className={styles.spinnerContainer}>
    <Spinner className={styles.spinner} />
  </div>
)

const CardImage = ({ height, isLoading, name, rotate, onlyBack, onlyFront, reverse, sideBySide, srcs, deckPreview }) => {
  if (isLoading) return <MySpinner />
  const srcsMod =
    reverse && srcs.length > 1
      ? [srcs[1], srcs[0]]
      : onlyBack && srcs.length > 1
      ? [srcs[1]]
      : onlyFront
      ? [srcs[0]]
      : srcs
  if (!srcs) return null
  return (
    <LazyLoad className={classNames(styles.image, {[styles.sideBySide]: sideBySide, [styles.deckPreview]: deckPreview})} height={height} offset={500} once placeholder={<MySpinner />}>
      {srcsMod.map((src, i, arr) => (
        <Img
          className={classNames(
            styles.image,
            {
              [styles.image180]: name === 'Mind Flayer, the Shadow',
              [styles.imageFront]: arr.length > 1 && !sideBySide && i === 0,
              [styles.imageBack]: arr.length > 1 && !sideBySide && i === 1,
              [styles.imageLeft]: arr.length > 1 && sideBySide && i === 0,
              [styles.imageRight]: arr.length > 1 && sideBySide && i === 1,
              [styles.image90]: rotate && i === 0,
              [styles.deckPreview]: deckPreview,
              [styles.deckPreviewFront]: arr.length > 1 && !sideBySide && i === 0 && deckPreview,
              [styles.deckPreviewBack]: arr.length > 1 && !sideBySide && i === 1 && deckPreview,
            },
            'shadow'
          )}
          key={v4()}
          src={src}
          alt={name}
          title={name}
          loader={<MySpinner />}
        />
      ))}
    </LazyLoad>
  )
}

CardImage.propTypes = {
  ...cardProps,
  height: PropTypes.any,
  isLoading: PropTypes.any,
  srcs: PropTypes.any,
}

export default CardImage
